import { orvalClient } from "@api/client";

export const fetchAttachment = async (url: string, filename = "report.xlsx") => {
  if (!url) {
    return [];
  }
  try {
    const token = typeof window !== "undefined" ? localStorage.getItem("acweb_access") : null;
    const response = await orvalClient.request<ArrayBuffer>({
      method: "GET",
      url,
      responseType: "arraybuffer",
      timeout: 30_000,
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    const arrayBuffer = response.data;
    const base64 = arrayBufferToBase64(arrayBuffer);
    return [
      {
        filename,
        content: base64,
        content_type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    ];
  } catch {
    throw new Error("Не удалось получить файл для письма");
  }
};

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  bytes.forEach((b) => {
    binary += String.fromCharCode(b);
  });
  return btoa(binary);
};
